const $ = jQuery.noConflict();

export const enhancer = () => {
  $('.information-grid + .buttons .button').click(function(e) {
    $(this).parent().prev().find('.information-grid__item.is-hidden').removeClass('is-hidden');
    $(this).parent().remove();
    e.preventDefault();
  });
};
